import { useAuth0 } from "@auth0/auth0-react";
import { ACR } from "../../service/auth/ACR";
import {faEdit} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export function ChangeAuthFlowButton({ change_type, email }) {
    const { loginWithRedirect } = useAuth0();

    const handleClick = async () => {
        try {
            await loginWithRedirect({
                appState: {
                    returnTo: "/account-settings",
                },
                authorizationParams: {
                    connection: "customers-db",
                    change_type,
                    acr_values: ACR.MFA,
                    max_age: 0,
                    login_hint: email || "",
                    prompt: "login",
                },
            });
        } catch (e) {
            console.error("Auth0 redirect error:", e);
        }
    };

    return (
        <button type="button" className="edit-icon" onClick={handleClick}>
            <FontAwesomeIcon icon={faEdit} />
        </button>
    );
}